import clsx from 'clsx';

import './button.css';

import React, { ButtonHTMLAttributes } from 'react';
import { Link } from 'react-router-dom';

import { IconLoader2 } from '@tabler/icons-react';

interface ICustomButton extends ButtonHTMLAttributes<HTMLButtonElement> {
  label?: string;
  icon?: React.ReactNode;
  isRightIcon?: boolean;
  variant?: 'primary' | 'outline';
  desructive?: boolean;
  href?: string;
  loading?: boolean;
}

interface ICustomLink extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant: 'link';
  href?: string;
  label?: string;
  icon?: React.ReactNode;
  isRightIcon?: boolean;
  desructive?: boolean;
  loading?: boolean;
}

type TButton = ICustomButton | ICustomLink;

const Button: React.FC<TButton> = ({
  label,
  type = 'button',
  onClick,
  icon,
  disabled,
  isRightIcon = false,
  className,
  variant,
  desructive,
  href,
  loading = false,
  ...rest
}) => {
  if (variant === 'link') {
    const LinkComponent = disabled ? 'div' : Link;

    if (href)
      return (
        <LinkComponent
          className={clsx(
            'btn-link',
            desructive && 'btn-destructive',
            disabled ? 'disabled' : 'cursor-pointer',
            className
          )}
          to={href}
          role={type}
        >
          {!isRightIcon && icon}
          {label}
          {isRightIcon && icon}
        </LinkComponent>
      );

    return (
      <button
        className={clsx(
          'btn-link',
          desructive && 'btn-destructive',
          disabled ? 'disabled' : 'cursor-pointer',
          className
        )}
        onClick={onClick}
        role={type}
      >
        {!isRightIcon && icon}
        {label}
        {isRightIcon && icon}
      </button>
    );
  }

  const buttonVariant =
    (variant ?? 'primary') === 'primary' ? 'btn-primary' : 'btn-outline';

  return (
    <button
      className={clsx(
        buttonVariant,
        desructive && 'btn-destructive',
        disabled ? 'cursor-not-allowed' : 'cursor-pointer',
        className,
        'flex items-center justify-center'
      )}
      type={type}
      onClick={onClick}
      disabled={disabled}
      {...rest}
    >
      {loading ? (
        <IconLoader2 className="animate-spin h-5 w-5 text-white" />
      ) : (
        <>
          {!isRightIcon && icon}
          {label}
          {isRightIcon && icon}
        </>
      )}
    </button>
  );
};

export default Button;
